import React, { useEffect, useState } from "react";
import { ImageOverlay, useMap } from "react-leaflet";
import L from "leaflet";
import { useAnalysis } from "../../contexts/AnalysisContext";
import { useDateSelection } from "../../contexts/DateSelectionProvider";
import Notification from "./Notification";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { urls } from "../../services/apiService";
const MySwal = withReactContent(Swal);

const ImageOverlayWithBounds = ({ coordinate, index, getBound, selectedField }) => {
  const { msaviResults, ndviResults, ndreResults, ndmiResults, nccResults } = useAnalysis();
  const [cleanedUrl, setCleanedUrl] = useState(null);
  const [alertShown, setAlertShown] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [loading, setLoading] = useState(false);
  const { selectedUrl } = useDateSelection();
  const [opacity, setOpacity] = useState(1); // Use opacity state here
  const map = useMap();

  const polygon1 = {
    type: "Polygon",
    coordinates: [coordinate],
  };

  const bounds = L.geoJSON(polygon1).getBounds();

  useEffect(() => {
    // Fit the map bounds when the component mounts
    map.fitBounds(bounds);
    getBound(bounds);
  }, [coordinate]);

  useEffect(() => {
    // Show loader when selectedUrl changes
    if (selectedUrl) {
      setLoading(true); // Start loader
      setShowNotification(false);
      const cleaned = selectedUrl.replace(/^'|'$/g, "");
      let modifiedUrl = cleaned.replace("mysite/", "");
      setCleanedUrl(modifiedUrl);
      setAlertShown(true);
    } else if (!selectedUrl && !alertShown) {
      setShowNotification(true);
    }
  }, [index, selectedUrl, msaviResults, ndviResults, ndreResults, ndmiResults, nccResults]);

  // Function to close the notification
  const handleCloseNotification = () => {
    setShowNotification(false);
  };

  // Use this to close the loader when the image is loaded
  const handleImageLoad = () => {
    setLoading(false); // Stop loader
  };

useEffect(() => {
  let timer;

  if (loading) {
    MySwal.fire({
      title: "Loading image...",
      html: "Please wait while the image loads.",
      allowOutsideClick: true,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    // Auto-close after 4 seconds
    timer = setTimeout(() => {
      Swal.close();
    }, 4000);
  } else {
    Swal.close(); // Close immediately when loading is false
  }

  return () => clearTimeout(timer); // Clear timeout on unmount or loading change
}, [loading]);


 // Set opacity from localStorage only on mount
 useEffect(() => {
  const storedOpacity = localStorage.getItem("opacity");
  if (storedOpacity) {
    setOpacity(Number(storedOpacity));
  }
}, []);

  // Poll every second for changes in localStorage
  useEffect(() => {
    const intervalId = setInterval(() => {
      const storedOpacity = localStorage.getItem("opacity");
      if (storedOpacity) {
        setOpacity(Number(storedOpacity)); // Update the state if localStorage value has changed
      }
    }, 1000); // Check every second

    // Clean up the interval on component unmount
    return () => {
      clearInterval(intervalId);
    };
  }, []); // Empty dependency array to ensure this runs once when the component mounts

  return (
    <div>
      {cleanedUrl && (
        <ImageOverlay
          style={{ cursor: "pointer" }}
          opacity={opacity} // Use the opacity state directly here
          url={`${urls.base}/${cleanedUrl}`}
          bounds={bounds}
          interactive={true}
          zIndex={1}
          eventHandlers={{
            load: handleImageLoad, // Handle when image has loaded
          }}
        />
      )}
      {showNotification && (
        <Notification message="Select Your date to view the image" onClose={handleCloseNotification} />
      )}
    </div>
  );
};

export default React.memo(ImageOverlayWithBounds);
